import React, { Component } from 'react';
import { Formik } from 'formik';
import { Space, Button, Form, Alert } from "antd";
import * as Yup from 'yup';
import * as constants from '../constants';

import common from '../../../common';
import core from '../../core';

const { TextArea, DisplayFormikState } = core;
const FormItem = Form.Item;
const ButtonGroup = Button.Group;

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 4,
        },
    },
};

class WorkflowRemarkForm extends Component {

    onSave = async (values, { setSubmitting, setErrors }) => {
        if (this.props.onSave) {
            try {
                await this.props.onSave(values);
                setSubmitting(false);
            } catch (error) {
                setSubmitting(false);
                setErrors();
            }
        } else {
            setSubmitting(false)
        }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'WorkflowRemarkForm', key);
    }

    FormSchema = (initialvalues) => {
        let schema = Yup.object().shape({
            remark: Yup.string().min(3).required('*'),
        })

        return schema;
    }

    CreateForm = (props) => {

        return (
            <Form layout='horizontal' style={{ margin: 10 }}>
                <TextArea {...props} name="remark" label={this.label("Remark")} rows={5} formItemLayout={formItemLayout} />
                <FormItem {...tailFormItemLayout}>
                    <ButtonGroup className='entity-form-btns'>
                        <Button disabled={props.isSubmitting} onClick={this.props.onCancel}>{this.label("Cancel")} </Button>
                        <Button type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting} > {this.label("Save")} </Button>
                    </ButtonGroup>
                </FormItem>
                {props.isSubmitting &&
                    <Alert
                        message={this.label("Saving")}
                        style={{ marginTop: 20 }}
                    />
                }
                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true} validateOnBlur={false} validateOnChange={false}
                initialValues={this.props.datacontext}
                validationSchema={this.FormSchema(this.props.datacontext)}
                onSubmit={this.onSave}
                innerRef={p => (this.formik = p)}
            >
                {(props) => this.CreateForm(props)}
            </Formik>
        );
    }
}

export default WorkflowRemarkForm;


